import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter, Subscription } from 'rxjs';
import { CommonService } from './Services/common.service';
import { LoadingService } from './Services/loading.service';
import { LenisService } from './Services/lenis.service';
import { environment } from '../environments/environment';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrl: './app.component.css',
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private routeSub?: Subscription;
  private loadingSub?: Subscription;

  constructor(
    public shared: CommonService,
    public loadingService: LoadingService,
    private lenisService: LenisService,
    private router: Router,
    private cdr: ChangeDetectorRef
  ) { }
  title = 'ElectraMaster_Fe';

  ngOnInit(): void {
    // Keep change detection responsive on loader state changes
    this.loadingSub = this.loadingService.isLoading$.subscribe(() => {
      this.cdr.markForCheck();
    });

    if (environment.enableLenis) {
      this.routeSub = this.router.events
        .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
        .subscribe((event) => {
          const url = (event.urlAfterRedirects || event.url || '').toLowerCase();
          const isAdmin = url.startsWith('/admin') || url.includes('/admin/');
          if (isAdmin) {
            this.lenisService.destroy();
          } else {
            this.lenisService.init();
          }
        });

      // Initial route
      const initialUrl = (this.router.url || window.location.pathname || '').toLowerCase();
      const isAdminInitial = initialUrl.startsWith('/admin') || initialUrl.includes('/admin/');
      if (isAdminInitial) {
        this.lenisService.destroy();
      } else {
        this.lenisService.init();
      }
    } else {
      this.lenisService.destroy();
    }
  }

  ngOnDestroy(): void {
    this.routeSub?.unsubscribe();
    this.loadingSub?.unsubscribe();
    this.lenisService.destroy();
  }
}
